import { bundleId, recent_viewed_key } from '../../Constants/ProductPage';
import { getFilteredData } from '../commonUtils';
import { getFilteredCategoryContent } from '../helper';
import { productPriceFetcher } from '../../datafetchers/productPage';

export const getProductIdfromUrl = (webUrl) => {
  if (Array.isArray(webUrl)) {
    webUrl = webUrl?.pop();
  }
  return webUrl.split('-').pop();
};

export const getCookies = async () => {
  return (await import('js-cookie')).default;
};

export const getPriceFetcher = async () => {
  return productPriceFetcher;
};

export const dynamicOpenDeepLink = async (value, url) => {
  const opeAppnDeepLink = (await import('../../../src/Utils/androidUtils'))
    .isAndroidOpenDeeplink;
  opeAppnDeepLink(value, url);
};

export const fireConversionEvent = async (RandomEventId, productId) => {
  const fbConversionEvent = (await import('../../../src/Libs/fbpixel'))
    .fireFbConversionApiEvent;

  fbConversionEvent(
    'ViewContent',
    {
      content_ids: productId,
      content_type: 'product',
    },
    RandomEventId,
  );
};

export const fbFixelTrackEvent = (RandomEventId, productId) => {
  if (typeof window?.fbq === 'function')
    window?.fbq(
      'track',
      'ViewContent',
      {
        content_ids: productId,
        content_type: 'product',
      },
      { eventID: RandomEventId },
    );
};

export const productKeysToEmpty = [
  'offertags',
  'reviews',
  'discussion',
  'categoriesData',
  'comboProductIds',
  'sharetext',
  'product_banners',
  'adjustment_booster',
  'tags',
  'recently_viewed_products',
  'similar_products_data',
  // "widgets",
];
export const getFilteredProductData = (productData) => {
  productData.categories = getFilteredCategoryContent(productData.categories);
  productKeysToEmpty.map((key) => {
    productData.data[key] = [];
  });
  const filteredWidgetData = productData?.data?.widgets?.map((key) => {
    const widgetContentData = key?.widgetContent?.map((element) =>
      getFilteredData(element, widgetContentFilterKeys),
    );
    const widgetData = getFilteredData(key, widgetDataFilterKeys);
    widgetData.widgetContent = [...widgetContentData];

    return widgetData;
  });
  productData.data.widgets = filteredWidgetData;
  return productData;
};

export const updateOfferStripData = async (offerStripData) => {
  const Cookies = await getCookies();
  Cookies.set('offer_strip_data', JSON.stringify(offerStripData), '/');
};

export const shouldForceClick = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const forceAdded = sessionStorage.getItem('alreadyAdded');
  const ovalunaHardCheck =
    !forceAdded &&
    searchParams.get('utm_campaign') === 'ovaluna_pdp' &&
    searchParams.get('utm_source') == 'crm';

  if (ovalunaHardCheck) {
    sessionStorage.setItem('alreadyAdded', true);
  }

  return searchParams.get('key') || ovalunaHardCheck || false;
};

export const isDesktopUser = () => {
  return typeof window !== 'undefined' && window.innerWidth >= 720;
};

export const offerFilterKeys = [
  'expire_date',
  'offerPrice',
  'name',
  'description',
  'code',
  'offer_heading',
  'term_id',
  'cart_min_amount',
];
export const widgetContentFilterKeys = [
  'body',
  'heading',
  'url',
  'imageAltName',
  'fallbackAltName',
  'specialization',
];
export const widgetDataFilterKeys = [
  'type',
  'title',
  'content_align',
  'grid_column',
  'is_policy',
  'default_collapsed',
];
export const addProductToRecentltViewedSection = (productData) => {
  let recentData = localStorage.getItem(recent_viewed_key) || [];
  if (recentData.length) {
    recentData = JSON.parse(localStorage.getItem(recent_viewed_key));
  }
  const product = {
    id: productData?.id,
    name: productData?.name,
    price: productData?.price,
    showImage: productData?.images[0],
    strikeprice: productData?.strikeprice,
    type: productData?.type,
    web_url: productData?.web_url,
    textFlag: productData?.textFlag,
  };
  recentData = recentData.filter((product) => product?.id != productData?.id);
  recentData.unshift(product);
  localStorage.setItem(recent_viewed_key, JSON.stringify(recentData));
};

export const getLocalRecentProducts = (productId) => {
  let recent_data = localStorage.getItem(recent_viewed_key) || [];
  if (recent_data.length) {
    recent_data = JSON.parse(recent_data);
    recent_data = recent_data.filter((data) => data.id != productId);
  }
  return recent_data;
};

export const getProductName = (productData) => {
  if (productData?.id == bundleId) {
    let data = productData?.nickname?.split(' ');
    data?.shift();
    const newName = data?.join(' ');
    return newName;
  } else return productData?.nickname;
};

export const getClosestSunday = () => {
  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  // Calculate the number of days until the next Sunday
  const daysUntilSunday = (7 - currentDay) % 7;
  // Create a new date by adding the days until Sunday
  const nextSunday = new Date(currentDate);
  nextSunday.setDate(currentDate.getDate() + daysUntilSunday);
  nextSunday.setHours(23, 59, 0, 0);
  return nextSunday;
};

export const getPreviousMonday = (timestamp) => {
  var date = new Date(timestamp);
  var day = date.getDay(); // Get the day of the week (0 for Sunday, 1 for Monday, and so on)

  var daysToMonday = (day + 6) % 7; // Calculate the number of days to subtract to reach the previous Monday
  date.setDate(date.getDate() - daysToMonday);
  date.setHours(0, 0, 0, 0);
  return date.toISOString();
};

function extractFeaturesString(inputString) {
  const lastPipeIndex = inputString.lastIndexOf('|');
  let returnValue = inputString;
  if (lastPipeIndex !== -1) {
    const remainingString = inputString.substring(lastPipeIndex + 1);
    let dashIndex = remainingString.indexOf('-');
    if (remainingString.substring(dashIndex + 1, dashIndex + 4) === 'Tex')
      dashIndex = remainingString.indexOf('-', dashIndex + 1);

    if (
      remainingString.substring(dashIndex - 1, dashIndex + 5) === '4-in-1' ||
      remainingString.substring(dashIndex + 1, dashIndex + 3) == 'to'
    )
      dashIndex = remainingString.lastIndexOf('-');

    const openParenIndex = remainingString.indexOf('(');
    const endIndex =
      dashIndex !== -1 && openParenIndex !== -1
        ? Math.min(dashIndex, openParenIndex)
        : dashIndex !== -1
          ? dashIndex
          : openParenIndex !== -1
            ? openParenIndex
            : remainingString.length;
    returnValue =
      inputString.substring(0, lastPipeIndex + 1) +
      remainingString.substring(0, endIndex);
  }
  return returnValue.trim().split('|').slice(1).join('|').replace(/, /g, ' | ');
}
